import { Controller } from '@hotwired/stimulus'

export default class AdminProjectFormController extends Controller {
  static targets = [];
  static values = {
    onlyOnetabId: String,
    onlyOnetabError: String,
    onlyOnetabErrorRedirectUrl: String,
  }

  connect() {
    const channel = this.initCheckOnlyOneTab();
    this.showWarning = true;

    this.element.addEventListener('submit', (e) => {
      this.showWarning = false;
    });

    window.addEventListener('beforeunload', (e) => {
      if (channel) channel.close();
      clearInterval(this.interval);

      if (this.showWarning) {
        e.preventDefault();
        const confirmationMessage = '\\o/';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });

    this.autoSaveLoop();
  }

  initCheckOnlyOneTab() {
    if (!this.onlyOnetabIdValue) return;

    const channel = new BroadcastChannel(`tab-check-${this.onlyOnetabIdValue}`);
    channel.postMessage({ type: 'hello_world' });
    channel.onmessage = (event) => {
      if (event.data.type === 'hello_world') {
        channel.postMessage({ type: 'already_open' });
      } else if (event.data.type === 'already_open') {
        alert(this.onlyOnetabErrorValue);
        window.location.href = this.onlyOnetabErrorRedirectUrlValue;
      }
    };
    return channel;
  }

  autoSaveLoop() {
    this.interval = setInterval(() => {
      this.autoSave();
    }, 20000);
  }

  autoSave() {
    const form = this.element;

    const formData = new FormData(form);
    const keysToDelete = [];

    formData.forEach((value, key) => {
      if (form.querySelectorAll(`.disable-autosave [name="${key}"]`).length > 0) {
        keysToDelete.push(key);
      }
    });

    keysToDelete.forEach(key => {
      formData.delete(key);
    });

    const url = form.action;

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'accept': 'text/javascript',
      }
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          toastr.error('Unexpected error', '', {timeOut: 5000});
        }
      })
      .then(js => {
        eval(js);
      });
  }
}
